import Vue from 'vue';
import router from "./router.js";
import store from "./store.js";

//imports that used to be on the dom

import jQuery from 'jquery';
// import jqueryUI from 'jquery-ui';
import validate from "jquery-validation/dist/additional-methods.min.js"

import moment from 'moment';
import async from 'async';
import vueRouter from 'vue-router'
import Vuex from "vuex";
import maska from "maska";
// import vuejsDatepicker from "vuejs-datepicker";
import vuejsDatepicker from '@sum.cumo/vue-datepicker';
import VsNotify from 'vue-notifyjs'
import VueGtm from '@gtm-support/vue2-gtm';
import VueCarousel from 'vue-carousel';
import VTooltip from 'v-tooltip'

//utils
import InputText from "./components/utils/InputText.js";
import InputSelect from "./components/utils/InputSelect.js";
import InputComboBox from "./components/utils/InputComboBox.js";
import InputCheckbox from "./components/utils/InputCheckbox.js";
import Button from "./components/utils/Button.js";
import TextBlock from "./components/utils/TextBlock.js";
import InputPhone from "./components/utils/InputPhone.js";
import InputDate from "./components/utils/InputDate.js";
import TextInline from "./components/utils/TextInline.js";
import BannerBtn from "./components/utils/BannerBtn.js";
import QuoteCard from "./components/utils/QuoteCard.js";
import QuoteCarousel from "./components/utils/QuoteCarousel.js";
import InputRange from "./components/utils/InputRange.js";
import Alert from "./components/utils/Alert.js";

//components
import Ads from "./components/Ads.js";
import altAddress from "./components/altAddress.js";
import IntroZip from "./components/IntroZip.js";
import Loading from "./components/Loading.js";
import Progress from "./components/progress.js"
import PageComponent from "./components/Page.js";
import AppComponent from "./components/App.js";
import CarrierRadio from "./components/CarrierRadio.js";
import InputCoverageSelector from "./components/InputCoverageSelector.js";
import HomePrefill from "./components/HomePrefill.js";
import modal from "./components/modal.js";
import petSummaryCard from "./components/petSummaryCard.js"; 

import Funnel from "./services/funnel-service.js";
import Validation from "./services/validation-service.js";
import { submitError } from "./errors.js";

Vue.use(maska);
Vue.use(VsNotify);
Vue.use(VueCarousel);
Vue.use(VTooltip)

if (gtmDimensions && bindableGTM.indexOf('GTM-') >= 0) {
    const containerArray = [bindableGTM];

    if (gtm) {
        containerArray.push(gtm);
    }

    Vue.use(VueGtm, {
        id: containerArray,
        // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
        // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
        // nonce: '2726c7f26c', // Will add `nonce` to the script tag
        // enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: false, // Whether or not display console logs debugs (optional)
        loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        // ignoredViews: [], // Don't trigger events for specified router names (optional)
        // trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
    });

    for (const item of gtmDimensions) {
        window.dataLayer?.push({
            [item.dimension]: item.value
        });
    }
}

const App = {
    el: '#tacqu_app',
    store: store,
    router,
    components: {
        'AppComponent': AppComponent,
        'PageComponent': PageComponent,
        'Loading': Loading,
        'Progress': Progress,
        'InputText': InputText,
        'InputSelect': InputSelect,
        'InputComboBox': InputComboBox,
        'InputCheckbox': InputCheckbox,
        'Button': Button,
        'IntroZip': IntroZip,
        'TextBlock': TextBlock,
        'InputPhone': InputPhone,
        'InputDate': InputDate,
        'altAddress': altAddress, 
        'TextInline': TextInline,
        'CarrierRadio': CarrierRadio,
        'BannerBtn': BannerBtn,
        "QuoteCard": QuoteCard,
        "QuoteCarousel": QuoteCarousel,
        "Alert": Alert,
        'InputCoverageSelector': InputCoverageSelector,
        'HomePrefill': HomePrefill,
        'InputRange': InputRange,
        'modal': modal,
        'Notify': VsNotify,
        'v-tooltip': VTooltip,
        "Ads": Ads,
        "petSummaryCard": petSummaryCard
    },
    errorCaptured: function (err, vm, info) {
        const msg = err.name + ': ' + err.message

        const data = {
            "message": msg,
            "stack": err.stack,
            "info": info,
            "element_info": JSON.stringify(vm.input)
        }

        submitError(data)
    }
};

window.addEventListener('error', (e) => {
    const data = {
        "message": e.message,
        "error_message": e.error.message,
        "stack": e.error.stack,
        "error_data": JSON.stringify(e.error)
    }

    submitError(data);
});

window.addEventListener('load', () => {
    new Vue(App);
    new Validation({ ctx: App.store, router: router }).init();
});

export default App;
